export interface NavigationItem {
    label: string
    href: string
}

export const mainNavigation: NavigationItem[] = [
    {
        label: 'Como funciona',
        href: '/#como-funciona'
    },
    {
        label: 'Simulador',
        href: '/#simulador'
    },
    {
        label: 'Sorteio e lance',
        href: '/#contemplacao'
    },
    {
        label: 'Dúvidas',
        href: '/#duvidas'
    }
]

export const footerNavigation: NavigationItem[] = [
    {
        label: 'Como funciona',
        href: '/#como-funciona'
    },
    {
        label: 'Simulador de parcelas',
        href: '/#simulador'
    },
    {
        label: 'Sorteio e lance',
        href: '/#contemplacao'
    },
    {
        label: 'Consórcio ou financiamento',
        href: '/#comparativo'
    },
    {
        label: 'Consultoria',
        href: '/#consultoria'
    },
    {
        label: 'Dúvidas frequentes',
        href: '/#duvidas'
    }
]
